import { render, staticRenderFns } from "./Pendapatan.vue?vue&type=template&id=198b6b3f&scoped=true&"
import script from "./Pendapatan.vue?vue&type=script&lang=js&"
export * from "./Pendapatan.vue?vue&type=script&lang=js&"
import style0 from "./Pendapatan.vue?vue&type=style&index=0&id=198b6b3f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "198b6b3f",
  null
  
)

export default component.exports